import React, { useState, useEffect, useContext } from "react";
import { Modal, Form, Input, Select } from "antd";
import { useAtom } from "jotai";
import {visibleModalRegimenPensionarioAtom } from "pages/movil/PerfilMovilStore";
import { UbigeoService } from "services";
import { SecurityContext } from "context/SecurityContextProvider";
import { PortalColaboradorService } from "services/PortalColaboradorService";

const ModalEditarEditarRegimenPensionario = ({ colaborador, setColaborador }) => {
	const [visibleModal, setVisibleModal] = useAtom(visibleModalRegimenPensionarioAtom);
	const [formulario] = Form.useForm();
	const { getUsuarioAutenticado } = useContext(SecurityContext);
	const tipoRegimenPensionario = Form.useWatch(["regimenPensionario", "tipo"], formulario);
	
	useEffect(() => {
		const cargarDatos = async () => {
			formulario.setFieldsValue({
				regimenPensionario: {
					tipo: colaborador?.regimenPensionario?.tipo,
					cusppAfp: colaborador?.regimenPensionario?.cusppAfp,
					nombreAfp: colaborador?.regimenPensionario?.nombreAfp,
				},
			});
		};

		cargarDatos();
	}, [colaborador]);
	
	// Limpiar campos cuando cambie el tipo a ONP o NINGUNO
	useEffect(() => {
		if (tipoRegimenPensionario !== "AFP") {
			formulario.setFieldsValue({
				regimenPensionario: {
					...formulario.getFieldValue("regimenPensionario"),
					cusppAfp: null,
					nombreAfp: null,
				},
			});
		}
	}, [tipoRegimenPensionario]);
	
	const handleCancel = async () => {
		setVisibleModal(false);
		formulario.resetFields();
	};

	const handleActualizar = async (colaborador) => {
		colaborador.datosPersonales = {
			numeroDocumentoIdentidad: getUsuarioAutenticado().numeroDocumentoIdentidad,
		};
		await PortalColaboradorService.actualizarRegimenPensionario(colaborador);
		
		const response = await PortalColaboradorService.buscarColaborador();
		setColaborador(response);
		handleCancel();
	};

	return (
		<Modal title="Editar Regimen Pensionario" open={visibleModal} onOk={() => formulario.submit()} onCancel={handleCancel}>
			<Form
				layout="horizontal"
				labelCol={{
					span: 6,
				}}
				wrapperCol={{
					span: 18,
				}}
				form={formulario}
				onFinish={handleActualizar}
				initialValues={{
					regimenPensionario: {
						tipo: colaborador?.regimenPensionario?.tipo,
						cusppAfp: colaborador?.regimenPensionario?.cusppAfp,
						nombreAfp: colaborador?.regimenPensionario?.nombreAfp,
					},
				}}
			>
				<Form.Item label="Tipo" name={["regimenPensionario", "tipo"]} rules={[{ required: true }]}>
					<Select allowClear>
						<Select.Option value="NINGUNO">NINGUNO</Select.Option>
						<Select.Option value="AFP">AFP</Select.Option>
						<Select.Option value="ONP">ONP</Select.Option>
					</Select>
				</Form.Item>
				<Form.Item
					label="CUSPP AFP"
					name={["regimenPensionario", "cusppAfp"]}
					rules={[{ required: tipoRegimenPensionario === "AFP" }]}
				>
					<Input disabled={tipoRegimenPensionario !== "AFP"} />
				</Form.Item>
				<Form.Item
					label="Nombre AFP"
					name={["regimenPensionario", "nombreAfp"]}
					rules={[{ required: tipoRegimenPensionario === "AFP" }]}
				>
					<Input disabled={tipoRegimenPensionario !== "AFP"} />
				</Form.Item>
			</Form>
		</Modal>
	);
};
export default ModalEditarEditarRegimenPensionario;
